import { render, staticRenderFns } from "./base_location_status.vue?vue&type=template&id=3168972d&scoped=true&"
import script from "./base_location_status.vue?vue&type=script&lang=js&"
export * from "./base_location_status.vue?vue&type=script&lang=js&"
import style0 from "./base_location_status.vue?vue&type=style&index=0&id=3168972d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168972d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3168972d')) {
      api.createRecord('3168972d', component.options)
    } else {
      api.reload('3168972d', component.options)
    }
    module.hot.accept("./base_location_status.vue?vue&type=template&id=3168972d&scoped=true&", function () {
      api.rerender('3168972d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_status/base_location_status.vue"
export default component.exports